import React from 'react';
import PropTypes from 'prop-types';

const DocImage = ({ className = '', width = 72, height = 72 }) => {
    return (
        <svg
            className={className}
            width={width}
            height={height}
            viewBox='0 0 72 72'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
            xmlnsXlink='http://www.w3.org/1999/xlink'
        >
            <rect
                x='0.5'
                y='0.5'
                width={71}
                height={71}
                rx='3.5'
                fill='url(#pattern0_3703_1047)'
                stroke='#E2F1F7'
            />
            <defs>
                <pattern
                    id='pattern0_3703_1047'
                    patternContentUnits='objectBoundingBox'
                    width={1}
                    height={1}
                >
                    <use
                        xlinkHref='#image0_3703_1047'
                        transform='matrix(0.00479711 0 0 0.00498491 -0.100363 0.00706797)'
                    />
                </pattern>
                <image
                    id='image0_3703_1047'
                    width={240}
                    height={160}
                    xlinkHref={
                        'data:image/png;base64,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'
                    }
                />
            </defs>
        </svg>
    );
};

DocImage.propTypes = {
    className: PropTypes.string,
    width: PropTypes.number,
    height: PropTypes.number,
};

export default DocImage;
